"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tripAdvisor = void 0;
const basic_1 = require("../basic");
const font_faces_1 = require("./font-faces");
const media_1 = require("../basic/media");
const fonts_1 = require("../basic/fonts");
const spaces_1 = require("../basic/spaces");
const colors_1 = require("../basic/colors");
exports.tripAdvisor = (0, basic_1.applyBase)({
    small: {
        icon: {
            width: '15px',
            height: '15px',
        },
        image: {
            objectFit: 'contain',
            height: '18px',
            width: '23px',
            [media_1.media.tablet]: {
                height: '27px',
                width: '45px',
            },
            [media_1.media.desktop]: {
                height: '27px',
                width: '45px',
            },
        },
        text: {
            fontWeight: 'normal',
        },
    },
    medium: {
        icon: {
            width: '16px',
            height: '16px',
        },
        image: {
            height: '30px',
            width: '50px',
            [media_1.media.tablet]: {
                height: '35px',
                width: '60px',
            },
            [media_1.media.desktop]: {
                height: '35px',
                width: '60px',
            },
        },
        text: {
            fontWeight: 'bold',
        },
    },
    detailsWrapper: {
        py: [4, '65px'],
        mx: [4, 0],
        '> .-info': {
            mb: 2,
        },
        '.-info-wrapper': {
            mb: [2, 3],
        },
    },
    detailsInfo: {
        flexDirection: ['column', 'row'],
        alignItems: [null, 'center'],
        fontSize: [null, '25px'],
        '.icon': {
            variant: ['icons.md', 'icons.md'],
            mr: [null, 2],
        },
        '.tripAdvisorInfoText': Object.assign(Object.assign({}, font_faces_1.FONT_SIZE.LARGE), { pt: ['13px', 0], ml: [null, 4] }),
        '.tripAdvisorInfoNumber': Object.assign({}, font_faces_1.FONT_SIZE.LARGE_BOLD),
    },
    detailedReview: {
        marginBottom: spaces_1.space[2],
        padding: `${spaces_1.space[3]} 0`,
        borderTop: '1px solid',
        borderBottom: '1px solid',
        borderColor: colors_1.colors.borderColor,
        [media_1.media.tablet]: {
            marginBottom: spaces_1.space[4],
        },
        '> h2': Object.assign(Object.assign({}, font_faces_1.FONT_SIZE.M), { mb: ['10px', 3] }),
        '> .rating-wrap': {
            display: 'flex',
            flexDirection: ['column', 'row'],
            flexWrap: 'wrap',
            gap: [null, '5px 0'],
        },
    },
    currentRatings: {
        '> h2': Object.assign(Object.assign({}, font_faces_1.FONT_SIZE.M), { mb: [4, '45px'] }),
    },
    detailsRating: {
        mr: [null, 5],
        mb: ['12px', 0],
        '.icon': {
            variant: [null, 'icons.md'],
            mr: [null, '6px'],
        },
    },
    ratingWrap: Object.assign({ display: 'flex', position: 'relative', alignItems: 'center' }, font_faces_1.FONT_SIZE.LARGE),
    copyrights: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        fontSize: fonts_1.fontSizes[1],
        [media_1.media.tablet]: {
            fontSize: fonts_1.fontSizes[2],
        },
        '> .-year': {
            paddingRight: spaces_1.space[2],
            [media_1.media.tablet]: {
                paddingRight: spaces_1.space[1],
            },
        },
        '> .-powered': {
            display: 'flex',
            alignItems: 'center',
            '> .-powered-text': {
                marginRight: spaces_1.space[2],
            },
        },
    },
    logo: {
        height: '20px',
        width: '120px',
    },
    reviewHeader: {
        width: ['100%', `${(3 / 10) * 100}%`],
        mb: [2, 1],
        pr: [2, 3],
        '.review-description': Object.assign(Object.assign({}, font_faces_1.FONT_SIZE.LARGE), { color: 'secondary', pt: 2, mb: 1, '.review-author, .review-region, .review-date': {
                '&:not(:last-child):after': {
                    display: 'inline-block',
                    content: '"/"',
                    pl: 1,
                    mr: 1,
                },
            } }),
    },
    moreLessButton: Object.assign({}, font_faces_1.FONT_SIZE.LINK_LARGE),
    commentTitle: Object.assign(Object.assign({}, font_faces_1.FONT_SIZE.XS), { mb: [2, 3] }),
    commentText: Object.assign(Object.assign({}, font_faces_1.FONT_SIZE.LARGE), { letterSpacing: [null, '0.7px'], whiteSpace: 'pre-wrap', mb: 1 }),
});
//# sourceMappingURL=trip-advisor.js.map